import React, {useState, type ReactNode} from "react";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {Navigate, useLocation} from "react-router-dom";
import {ThemeProvider} from "@rescui/ui-contexts";
import {useGridAccess} from "../access";
import {Link} from "react-router-dom";
import {useAuth} from "../../hooks/useAuth";
import {ErrorDialogProvider} from "../../layout/ErrorDialog";
import "../../App.css";
import "../../css/fonts.css";
import "../../layout/Toolbar/index.css";
import "@rescui/colors/lib/index.css";

function AccountContent({children}: {children: (role: string, email: string) => ReactNode}) {
  const {user, role, isLoading} = useAuth(), location = useLocation();
  const gridMode = useGridAccess();
  if (isLoading) return <div className="grid-auth-loading" role="status">Opening your workspace…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  if (gridMode === "disabled") return <div className="grid-auth-loading"><p>Grid is unavailable in this environment.</p><Link to="/">Back to Coverbaker</Link></div>;
  return <ThemeProvider theme="dark"><React.Fragment key={`${user.email}:${role}`}>{children(role, user.email)}</React.Fragment><ErrorDialogProvider /></ThemeProvider>;
}
export function GridAccountRoot({children}: {children: (role: string, email: string) => ReactNode}) {
  const [client] = useState(() => new QueryClient({defaultOptions: {queries: {retry: false, refetchOnWindowFocus: false, staleTime: 60_000}}}));
  return <QueryClientProvider client={client}><AccountContent>{children}</AccountContent></QueryClientProvider>;
}
